export const validateField = (name, value) => {
  // Validación en tiempo real
  // Si está vacío no muestra error mientras escribe
  if (!value.trim()) return "";

  switch (name) {
    case "name":
      return value.trim().length < 3
        ? "Debe contener al menos 3 caracteres"
        : "";

    case "phone":
      return /^[0-9]{7,15}$/.test(value)
        ? ""
        : "Ingresa un teléfono válido";

    case "email":
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ? ""
        : "Correo electrónico inválido";

    case "position":
      return value.trim().length < 2
        ? "Ingresa un cargo válido"
        : "";

    case "message":
      return value.trim().length < 20
        ? "Debe contener mínimo 20 caracteres"
        : "";

    default:
      return "";
  }
};

export const validateForm = (data) => {
  const errors = {};

  // Nombre
  if (!data.name.trim()) {
    errors.name = "El nombre es obligatorio";
  } else if (data.name.trim().length < 3) {
    errors.name = "Debe contener al menos 3 caracteres";
  }

  // Teléfono
  if (!data.phone.trim()) {
    errors.phone = "El teléfono es obligatorio";
  } else if (!/^[0-9]{7,15}$/.test(data.phone)) {
    errors.phone = "Ingresa un teléfono válido";
  }

  // Correo
  if (!data.email.trim()) {
    errors.email = "El correo es obligatorio";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
    errors.email = "Correo electrónico inválido";
  }

  // Cargo
  if (!data.position.trim()) {
    errors.position = "El cargo es obligatorio";
  } else if (data.position.trim().length < 2) {
    errors.position = "Ingresa un cargo válido";
  }

  // Mensaje
  if (!data.message.trim()) {
    errors.message = "La descripción es obligatoria";
  } else if (data.message.trim().length < 20) {
    errors.message = "Debe contener mínimo 20 caracteres";
  }

  return errors;
};